"use strict";

angular.module("admin")
	.controller("AdminExportsParametersCtrl", ["$scope", "toastr", "AdminClientsService", "$location",
		function ($scope, toastr, AdminClientsService, $location) {

			AdminClientsService.getCurrentClient().then((client) => {
				$scope.data.client = client;
			});

			$scope.edit = function () {
				AdminClientsService.editClientExportParameters($scope.data.client).then((response) => {
					const data = response.data;
					toastr.success("", "Les paramètres d'export pour l'organisation " + data.code + " sont mis à jour");
					$location.path("/admin/export-templates");
				}).catch((response) => {
					const data = response.data;
					let errorMessage = "Problème lors de la mise à jour des paramètres d'export. ";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
			};
		}
	]);
